
















































import Button from '../../core/components/Button.vue';
import SimpleTable from '../../core/components/SimpleTable.vue';
import SectionTitle from '../../core/components/SectionTitle.vue';
import DatePickerSingle from '../../core/components/DatePickerSingle.vue';
import {
    EventBus,
    getCurrentTimestamp,
    substractTimeToDate,
    TypeEventBus,
} from '../../core/utils';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import {
    Combobox,
    MultipleSelect
} from '../../core/components';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import Loading from 'vue-loading-overlay';
import { SuscriptionsList, Template, UsersEmails, Suscription, Vehicle, AvailableVehiclesList, RadioOptions, RadioOption, DownloadReportsExcel, dateTypes, UserCompaniesReports, diffOptions, RefreshReport } from '../../core/models';
import { ReportsServices } from '../api/ReportsServices';
import moment from 'moment';

@Component({
    components: {
        Loading,
        Combobox,
        Button,
        SimpleTable,
        SectionTitle,
        MultipleSelect,
        DatePickerSingle
    }
})
export default class ModalReportRefresh extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop() visible: boolean;
    @Prop({default: null}) templateName: Template["template_name"];
    modalTitle: string = "Actualizar reporte";
    submitName: string = 'Actualizar';
    errorMsg: string = '';
    dateSelected: any = null;
    updatingReport: boolean = false;
    pendingAction: boolean = false;

    @Watch('visible')
    onVisibleChanged(value) {
        if (value) {
            this.loadInfo();
        }
    }


    showUserPreferences(){
        EventBus.$emit(TypeEventBus.SHOW_USER_PREFERENCES);
    }

    setErrorForm(text) {
        this.errorMsg = text;
    }

    updateDate(value) {
       this.dateSelected = value;
    }


    pendingLoadingDialog(msg){
        this.$_showLoadingDialog(msg);
    }
    handleSuccessAction(response, alternative_msg, timeout){
        this.$_successLoadingDialog({
            response: response,
            alternative_msg: alternative_msg,
            timeout: timeout
        });
        this.closeModal();
    }
    handleErrorAction(error, alternative_msg, timeout){
        this.$_catchLoadingDialog({
            response: error.response.data || {},
            alternative_msg: alternative_msg,
            timeout: timeout
        });
    }

    submitAction() {
        this.updateReport(
            this.dateSelected,
            this.templateName,
            false
        );
    }


    


    updateReport(
        date_from: string | null = null,
        template_name: string,
        refreshDirecly: boolean = false
    ){
        //este metodo tambien se llama desde el listado de Configuraciones > Gestion de Reportes
        this.updatingReport = true;
        let refreshParams: RefreshReport = {
            date_from: date_from,
            template_name: template_name,
            company_id: Number(this.$_getSelectedCompanyById)
        }

        if(refreshDirecly){
            refreshParams.date_from = null;
        }

        ReportsServices.refreshReport(
            refreshParams,
        ).then((res) => {
            this.updatingReport = false;
            this.handleSuccessAction(res, 'Reporte actualizado con éxito', 5000);

        }).catch((err) => {
            this.updatingReport = false;
            this.handleErrorAction(err, 'No se pudo actualizar el reporte', 5000);
        })
    }

    get datePickerEl(): HTMLFormElement {
        return this.$refs.datepickrangeexcel as HTMLFormElement;
    }

  

    @Emit()
    closeModal() {
        
    }

    loadInfo(){
     let currentDate = moment();
     let currentDateLessThreeDays = substractTimeToDate(currentDate, 3, diffOptions.days);
     this.updateDate(currentDateLessThreeDays.format(dateTypes.dateYearFormatReverse));       
    }

    mounted() {
        this.$nextTick(() => {
            this.loadInfo();
        });
    }
}
